import { useTranslation } from 'react-i18next';
import classes from './Banner.module.scss';
import Button from '../../GlobalComponents/Button/Button';

const Banner = () => {
    const { t } = useTranslation();
    return (
        <section className="container">
            <div className={classes.wrap}>
                <div className={classes.body}>
                    <div className={classes.head}>
                        <h1 className={`${classes.title} font-64`}>
                            {t('plumbing.banner.title')}
                        </h1>
                        <p className={`${classes.subtitle} font-20`}>
                            {t('plumbing.banner.subtitle')}
                        </p>
                    </div>
                    <div className={`${classes.text} txt-container font-16`}>
                        <p>{t('plumbing.banner.text_01')}</p>
                        <p>{t('plumbing.banner.text_02')}</p>
                    </div>
                    <Button white form>
                        {t('btn.consultation')}
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default Banner;
